import { useTranslation } from 'react-i18next';
import { Input } from '@/Domain/components/Shared/Input/Input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/Domain/components/Shared/Select/Select';
import { ParameterTypeEnum } from '@/Domain/enum/ParameterType.enum';

type Props = {
  name: string;
  type: ParameterTypeEnum;
  onChange: (value: string | boolean) => void;
  value: string;
};

export const TestResponseField = ({ name, onChange, type, value }: Props) => {
  const { t } = useTranslation('actions_page');
  const testId = `test-response-value-${name.replaceAll('{{', '').replaceAll('}}', '')}`;

  if (type === ParameterTypeEnum.String) {
    return (
      <Input
        data-testid={testId}
        key={`${name}-${type}`}
        size="sm"
        placeholder={t('sheet.form.test_response.form.placeholder')}
        type="text"
        value={value}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.stopPropagation();
            event.preventDefault();
          }
        }}
        onChange={(event) => onChange(event.target.value)}
      />
    );
  }

  if (type === ParameterTypeEnum.Int || type === ParameterTypeEnum.Float) {
    return (
      <Input
        data-testid={testId}
        key={`${name}-${type}`}
        size="sm"
        placeholder={t('sheet.form.test_response.form.placeholder')}
        type="number"
        value={value}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.stopPropagation();
            event.preventDefault();
          }
        }}
        onChange={(event) => onChange(event.target.value)}
      />
    );
  }

  if (type === ParameterTypeEnum.Boolean) {
    return (
      <Select value={value} onValueChange={(value) => onChange(value)} key={`${name}-${type}`}>
        <SelectTrigger className="w-full" data-testid={testId}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={'1'}>True</SelectItem>
          <SelectItem value={'0'}>False</SelectItem>
        </SelectContent>
      </Select>
    );
  }
};
